import React from 'react';
import useInfographic from './useInfographic';

const Infographic = props => {
  const { contentRef, id, className, tabId, children } = useInfographic(props);

  return (
    <div ref={contentRef} id={id} className={className} role="tabpanel" aria-labelledby={tabId}>
      {children}
    </div>
  );
};

export default Infographic;
